export default "__VITE_ASSET__BOPXcbO$__"